module.exports = __webpack_public_path__ + "static/bg (6)-ed8dec9dfb6a3434a17d052d3941da30.jpg";